export default "/images/lamoda.png?3364bb8c5e1c5df41770061368cda5bf";